import type { IconProps } from "./types";

export function ChevronUp({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.33196 0.202008C6.68546 -0.0864414 7.20748 -0.0660219 7.53704 0.263531L13.537 6.26353C13.8884 6.61502 13.8885 7.18555 13.537 7.53697C13.1856 7.88838 12.6151 7.88829 12.2636 7.53697L6.90032 2.17369L1.53704 7.53697C1.18561 7.88838 0.615078 7.88829 0.263598 7.53697C-0.0878698 7.1855 -0.0878624 6.615 0.263598 6.26353L6.2636 0.263531L6.33196 0.202008Z"
        fill={currentColor}
        transform="translate(5.1 8.1)"
      />
    </svg>
  );
}
